import { css } from 'theme-ui';
import styled from '../../lib/transient-styled';
import { SectionType } from '../../shared-styled/blocks/detailedPageBlocks';

export const SectionTypeFIReport = styled(SectionType)(
  css({
    '&': {
      position: 'initial',
      mb: '8px',
    },
  }),
);

export const SectionContainerFIReport = styled.div(({ $level = 0 }) =>
  css({
    mb: '24px',
    ml: $level ? `${$level * 12}px` : '0', // Only apply ml if level exists
  }),
);
